const modelName = 'Newsletter Subscriptions';
const modelNameSingular = 'Newsletter Subscription';
const endpoint = '/newsletter-subscriptions';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: false,
  canSearch: true,
  canExport: 'newsletter-subscriptions/export',
  endpoint,
  accessor: 'id',
};

export default setup;
